import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Alert as BootstrapAlert } from 'reactstrap';
import { Icon } from 'components/atoms/Icon/';
import qs from 'store/entities/QueryString';

import './Alert.scss';

const ns = 'xt-alert';

const Alert = ({
  children,
  className,
  animation,
  color,
  icon,
  ...otherProps
}) => {
  const modalView = qs.get('vmode') === 'modal';
  const classProps = classNames(
    ns,
    {
      'c8-on-modal': modalView
    },
    animation,
    className
  );
  return (
    <BootstrapAlert {...otherProps} color={color} className={classProps}>
      {icon && <Icon type={icon} className={`icon`} id={`${icon}_icon`} />}
      {children}
    </BootstrapAlert>
  );
};

Alert.propTypes = {
  animation: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  color: PropTypes.string,
  icon: PropTypes.string
};

Alert.defaultProps = {
  className: ''
};

export default Alert;



// WEBPACK FOOTER //
// ./src/components/atoms/Alert/Alert.js